import React from "react";
import './MultiSelectRoundedItem.css';

const MultiSelectRoundedItem = ({name, onclose, hideClose = false})=>{
    const truncateWords = (text, maxWords = 2) => {
        const words = text.split(" ");
        return words.length > maxWords
            ? words.slice(0, maxWords).join(" ") + "..."
            : text;
    };

    return(
        <div className="rounded-item-outer">
            <span>{truncateWords(name)}</span>
            {!hideClose && (
                <svg onClick={onclose} xmlns="http://www.w3.org/2000/svg" width="11" height="11" viewBox="0 0 11 11" fill="none">
                    <path d="M7.875 2.625L2.625 7.875" stroke="#030213" stroke-width="0.875" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M2.625 2.625L7.875 7.875" stroke="#030213" stroke-width="0.875" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
            )}
        </div>
    )
}

export default MultiSelectRoundedItem;